import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { Subscription, lastValueFrom } from 'rxjs';
import { StorageService } from 'src/app/services/auth/storage.service';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import {
  CheckoutJourneyCollectorConfig,
  SetupConfigurationService
} from 'src/app/services/setup-configuration.service';

@Component({
  selector: 'app-checkout-journey-collector',
  templateUrl: './checkout-journey-collector.component.html',
  styleUrl: './checkout-journey-collector.component.scss',
  providers: [MessageService]
})
export class CheckoutJourneyCollectorComponent implements OnInit, OnDestroy {
  private title = inject(Title);
  private setupConfigurationService = inject(SetupConfigurationService);
  private messageService = inject(MessageService);
  private subscriptions = new Subscription();

  config: CheckoutJourneyCollectorConfig | null = null;
  enabledControl = new FormControl<boolean>(false, { nonNullable: true });
  saving = false;
  dirty = false;

  async ngOnInit() {
    this.title.setTitle('Checkout Journey');
    this.subscriptions.add(
      this.enabledControl.valueChanges.subscribe(() => this.syncDirty())
    );
    await this.loadConfig();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  async loadConfig() {
    LoaderService.showLoader();
    try {
      this.config = await lastValueFrom(
        this.setupConfigurationService.getCheckoutJourneyCollector()
      );
      this.enabledControl.setValue(!!this.config?.isEnabled, {
        emitEvent: false
      });
      this.syncDirty();
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async save() {
    if (!this.config || this.saving || !this.dirty) {
      return;
    }
    const enabled = this.enabledControl.value;
    this.saving = true;
    LoaderService.showLoader();
    try {
      const updated = await lastValueFrom(
        this.setupConfigurationService.updateCheckoutJourneyCollector(
          enabled,
          StorageService.userId != null
            ? `user-${StorageService.userId}`
            : 'admin'
        )
      );
      this.config = updated;
      this.enabledControl.setValue(!!updated.isEnabled, { emitEvent: false });
      this.syncDirty();
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: `Coletor CheckoutJourney ${
          enabled ? 'habilitado' : 'desabilitado'
        }.`
      });
    } catch (error) {
      this.enabledControl.setValue(!!this.config.isEnabled, {
        emitEvent: false
      });
      this.syncDirty();
      AppDialogService.showErrorDialog(error);
    } finally {
      this.saving = false;
      LoaderService.showLoader(false);
    }
  }

  private syncDirty() {
    this.dirty =
      !!this.config && this.enabledControl.value !== !!this.config.isEnabled;
  }
}
